module.exports = __webpack_public_path__ + "static/media/reject.c7df273d.svg";